import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { css } from "styled-components";

headerStyles.title = {
    color: "primary",
    size: "2rem",
    variant: "h1",

    css: css`
        margin: 0;

        @media print {
            font-size: 24px;
        }
    `,
};

headerStyles.addToListButton = {
    css: css`
        display: none;
    `,
};

headerStyles.continueButton = {
    css: css`
        display: none;
    `,
};

headerStyles.addToListClickable = {
    css: css`
        display: none !important;
    `,
};

headerStyles.continueClickable = {
    css: css`
        display: none !important;
    `,
};
